const __WEBPACK_NAMESPACE_OBJECT__ = require("@segment/analytics-node");